import { AibBlockLine } from "aic";
import { removeStylesFromEditorV3 } from "editor-v3";
import { STYLES_TO_CLEAN, STYLES_TO_DELETE } from "../../../config";

/**
 * Removes Optional and Notes styles from a BlockLine structure (used in Titles and Footnotes).
 *
 * Each position of a BlockLine is processed independently by removeStylesFromEditorV3, which:
 * - Processes IEditorV3 content by removing Optional and Notes styles
 * - Returns null or non-IEditorV3 content unchanged
 *
 * Note: External singles with styles are NOT applied here. They should be promoted to
 * TLF-level singles separately (see RemoveStylesModal for reference).
 *
 * @template T - Content type (typically IEditorV3 or null)
 * @param line - The BlockLine to process, containing left/center/right content positions
 * @returns A new BlockLine with styles removed from all IEditorV3 positions.
 *          Null or non-IEditorV3 content in any position is preserved as-is.
 */
export const removeStylesFromBlockLine = <T>(line: AibBlockLine<T>): AibBlockLine<T> => {
  return {
    ...line,
    left: removeStylesFromEditorV3(line.left, STYLES_TO_DELETE, STYLES_TO_CLEAN),
    center: removeStylesFromEditorV3(line.center, STYLES_TO_DELETE, STYLES_TO_CLEAN),
    right: removeStylesFromEditorV3(line.right, STYLES_TO_DELETE, STYLES_TO_CLEAN),
  };
};
